import { Col, Row, TabPanel } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { Typography } from '@paypalcorp/ppods-react'
import React from 'react'

import StandardCheckoutImg from '../../../../img/payment-solutions/ill_StandardCheckout.png'
import AdvancedCheckoutImg from '../../../../img/payment-solutions/ill_advancedCheckout.png'
import SubscriptionsImg from '../../../../img/payment-solutions/ill_Subscriptions.png'
import { saveBannerProgress } from '../../../../utils/session-utils'
import { useApplicationContext } from '../../../../context/ApplicationContext'

export default function MostPopular({ setBannerPage, setProductIntegration }) {
  const { csrf, logger, setCurrentBannerStep } = useApplicationContext()
  return (
    <>
      <TabPanel id="group4-panel1" tabId="group1-panel1">
        <Row className="onboarding-banner-cards-row">
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'stdCheckout',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('stdCheckout')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={StandardCheckoutImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabOne.productOne" />
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabOne.productOneDesc" />
              </Typography>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'advCheckout',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('advCheckout')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={AdvancedCheckoutImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabOne.productTwo" />
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabOne.productTwoDesc" />
              </Typography>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'subscriptions',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('subscriptions')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={SubscriptionsImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabOne.productThree" />
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabOne.productThreeDesc" />
              </Typography>
            </div>
          </Col>
        </Row>
      </TabPanel>
    </>
  )
}
